import React from "react";
import { DocAccountMap, DocAccountProps } from "../../Language";
import { AgreementKFSV as SV } from "./AgreementKFSV";
import "../../Documents.css";

const docsMap: DocAccountMap = { SV };

export const AgreementKF: React.FC<DocAccountProps> = (props) =>
  React.createElement(docsMap[props.language], props);
